import Swiper from "swiper";
import { equalHeight } from "./equal-height";

let customBlogSwiper = null;

export function initBlogSlider() {

    const tatvaBlogSection = document.querySelector(
        ".custom-tatva-blog-section"
    );

    if (!tatvaBlogSection) return;

    const updateEqualHeight = () => {
        equalHeight(
            ".custom-tatva-blog-section .custom-tatva-blog-grid .blog-item-content h3"
        );

        equalHeight(
            ".custom-tatva-blog-section .custom-tatva-blog-grid .blog-item-content p"
        );
    };

    updateEqualHeight();

    const slider = document.querySelector(
        ".custom-tatva-blog-section .custom-tatva-blog-grid .swiper"
    );

    if (!slider) return;

    const enableSlider = () => {
        if (window.innerWidth <= 992) {
            if (!customBlogSwiper) {
                customBlogSwiper = new Swiper(slider, {
                    slidesPerView: 2.5,
                    speed: 300,
                    loop: false,

                    breakpoints: {
                        0: {
                            slidesPerView: 1.1,
                        },
                        480: {
                            slidesPerView: 1.5,
                        },
                        768: {
                            slidesPerView: 2.5,
                        },
                    },

                    on: {
                        init() {
                            updateEqualHeight();
                        },
                        resize() {
                            updateEqualHeight();
                        },
                        imagesReady() {
                            updateEqualHeight();
                        }
                    }
                });
            }
        } else {
            if (customBlogSwiper) {
                customBlogSwiper.destroy(true, true);
                customBlogSwiper = null;
            }
        }
    };

    enableSlider();
    updateEqualHeight();

    window.addEventListener("load", () => {
        updateEqualHeight();
    });

    window.addEventListener("resize", () => {
        enableSlider();
        updateEqualHeight();
    });
}